module.exports = __webpack_public_path__ + "a00df6c7c2807376a6e12ff0ff72478b.svg";